<template>
	<div class="info-section" :class="{ stickied: stickied }">
		<TabBar
			v-if="tabBarVisible"
			:game="game"
			:tab-list="tabList"
			:stickied="stickied"
			:media-processed="mediaProcessed"
			:reqs-processed="reqsProcessed"
			:refs="refs"
			@setSticky="setSticky"
		></TabBar>
		<MediaSection v-if="showMedia" :media-list="filteredMediaList" :game="game" @setRef="setRef"></MediaSection>
		<DetailsSection v-if="showDetails" :game="game" @setRef="setRef"></DetailsSection>
		<SummarySection v-if="showSummary" :game="game" @setRef="setRef"></SummarySection>
		<RequirementsSection
			v-if="showReqs"
			:minimum="minimumSystem"
			:recommended="recommendedSystem"
			@setRef="setRef"
		></RequirementsSection>
		<div class="spacer"></div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getLocaleString } from '../../../plugins/helpers';
import TabBar from './tab-bar';
import MediaSection from './media-section';
import DetailsSection from './details-section';
import SummarySection from './summary-section';
import RequirementsSection from './requirements-section';

export default {
	name: 'GameDetailsInfoSection',
	components: {
		TabBar,
		MediaSection,
		DetailsSection,
		SummarySection,
		RequirementsSection,
	},
	props: {
		game: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			minimumSystem: [],
			recommendedSystem: [],
			stickied: false,
			mediaProcessed: false,
			reqsProcessed: false,
			refs: {
				media: null,
				details: null,
				summary: null,
				requirements: null,
			},
		};
	},
	computed: {
		...mapState(['mediaList']),
		showMedia() {
			return this.filteredMediaList.length > 0;
		},
		showDetails() {
			return !!(this.game.genre || (this.game.publisher && Object.keys(this.game.publisher).length > 0) || this.game.developer);
		},
		showSummary() {
			return !!(this.game.about && Object.keys(this.game.about).length > 0);
		},
		showReqs() {
			return this.minimumSystem.length > 0 || this.recommendedSystem.length > 0;
		},
		filteredMediaList() {
			return this.mediaList[this.game.name] || [];
		},
		tabList() {
			return [
				{
					id: 'media',
					show: this.showMedia,
				},
				{
					id: 'details',
					show: this.showDetails,
				},
				{
					id: 'summary',
					show: this.showSummary,
				},
				{
					id: 'requirements',
					show: this.showReqs,
				},
			].filter((tab) => tab.show);
		},
		tabBarVisible() {
			return this.tabList.length > 0;
		},
		language() {
			return this.$i18n.locale;
		},
		region() {
			return environment.region;
		},
	},
	mounted() {
		this.setGameRequirements();
	},
	async created() {
		this.getMediaList().finally(() => {
			this.mediaProcessed = true;
		});
	},
	methods: {
		...mapActions(['getMediaList']),
		setRef(type, ref) {
			this.refs[type] = ref;
		},
		setSticky(stickied) {
			this.stickied = stickied;
		},
		setGameRequirements() {
			this.processReqs('minimumSystem');
			this.processReqs('recommendedSystem');
			this.reqsProcessed = true;
		},
		processReqs(type) {
			this[type] = [];
			let reqs = getLocaleString(this.game[type], this.language);
			if (!reqs || Object.keys(reqs).length === 0) return;
			reqs = reqs.split('\n');
			const len = reqs.length;
			for (let i = 0; i < len; i++) {
				const req = reqs[i];
				this[type].push(req.split(':'));
			}
		},
	},
};
</script>

<style lang="less" scoped>
.info-section {
	background-color: #1f2023;
	padding-top: 1px;
	.spacer {
		height: 70px;
		width: 100%;
	}
}

@media (min-width: 768px) {
	.info-section {
		.spacer {
			height: 50px;
		}
	}
}

@media (min-width: 1024px) {
	.info-section {
		&.stickied {
			margin-top: 54px;
		}
		.spacer {
			height: 70px;
		}
	}
}

@media (min-width: 1440px) {
	.info-section {
		&.stickied {
			margin-top: 70px;
		}
		.spacer {
			height: 90px;
		}
	}
}
</style>
